import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const organizationForm = "https://airtable.com/shru2OXtkpN0EkOL0"
const volunteerForm = "https://airtable.com/shrq6uTUQeyZAtvmR"

const TextLink = ({ href, children }) => (
  <a className="underline text-blue-600 hover:text-blue-800" href={href}>
    {children}
  </a>
)

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>
    {children}
  </section>
)

export default function ContributePage() {
  return (
    <Layout contentClassName="bg-gray-100">
      <SEO
        title="Contribute to Donate for Dharma"
        description="Suggest a Hindu organization, send a correction, or volunteer with Donate for Dharma."
      />
      <div className="max-w-4xl mx-auto px-5 py-8 md:px-8 md:py-12">
        <h1 className="text-3xl font-semibold text-gray-900 mb-4">
          Help build Donate for Dharma
        </h1>
        <p className="text-gray-800 leading-relaxed">
          Donate for Dharma helps people find Hindu organizations working on
          temples, Sanskrit and shastra education, cow care, community service,
          research, media and advocacy. Help us keep the directory useful and
          accurate.
        </p>

        <div className="flex flex-col lg:flex-row leading-relaxed text-gray-800">
          <div className="lg:w-2/3 lg:pr-10">
            <Section title="Suggest an organization">
              <p>
                Know an organization working for a Hindu or dharmic cause that
                belongs here? Send us its name, website, a short description of
                its work, contact details and donation page, if available.
              </p>
              <p className="mt-3">
                <TextLink href={organizationForm}>Suggest an organization</TextLink>
              </p>
            </Section>

            <Section title="Send a correction">
              <p>
                Found a wrong logo, an outdated description or a donation link
                that no longer works? Email us the page URL and what needs to
                change. Include a link to the organization&apos;s website where
                we can check the details.
              </p>
              <p className="mt-3">
                <TextLink href="mailto:contact@donatefordharma.org">
                  contact@donatefordharma.org
                </TextLink>
              </p>
            </Section>

            <Section title="Volunteer with us">
              <p>
                Help research organizations, check contact and donation details,
                write descriptions, translate content or work on the website.
                Tell us what you would like to help with.
              </p>
              <p className="mt-3">
                <TextLink href={volunteerForm}>Volunteer with us</TextLink>
              </p>
            </Section>
          </div>

          <aside className="lg:w-1/3 lg:pl-6">
            <Section title="About the project">
              <p>
                Donate for Dharma is a volunteer-run directory and part of the{" "}
                <TextLink href="https://templesofindia.org/">
                  Temples of India
                </TextLink>{" "}
                project. Donations go directly to the organizations through the
                links on their pages.
              </p>
            </Section>

            <Section title="Contributors">
              <ul className="space-y-3">
                <li>
                  <TextLink href="https://www.linkedin.com/in/ayushx">
                    Ayush Maheshwari
                  </TextLink>
                  <span className="block text-sm text-gray-600">Lead</span>
                </li>
                <li>
                  <TextLink href="https://www.linkedin.com/in/arun-jayaramakrishnan-0362a9137/">
                    Arun JayaramaKrishnan
                  </TextLink>
                  <span className="block text-sm text-gray-600">Lead</span>
                </li>
                <li>
                  <TextLink href="https://adityaverm-a.vercel.app/">
                    Aditya Verma
                  </TextLink>
                  <span className="block text-sm text-gray-600">Developer</span>
                </li>
              </ul>
              <p className="mt-6 text-sm text-gray-600">
                Built using code from{" "}
                <TextLink href="https://climatescape.org">Climatescape</TextLink>.
              </p>
            </Section>
          </aside>
        </div>
      </div>
    </Layout>
  )
}
